import { BenefitsList } from './benefits-list';
import { BenefitsListFields } from "./benefits-list.fields";
import type { BenefitsListProps } from './benefits-list';
import type { ComponentConfig } from '@puckeditor/core';
import { RegenerableTextField } from "../editor/RegenerableTextField";

const BenefitsListConfig: ComponentConfig<BenefitsListProps> = {
  defaultProps: {
    benefits: [
      { text: "Licensed & Insured Professionals" },
      { text: "Upfront, Transparent Pricing" },
      { text: "Same-Day Service Available" },
      { text: "100% Satisfaction Guarantee" },
      { text: "24/7 Emergency Response" },
      { text: "Locally Owned & Operated" },
    ],
    columns: "3",
    heading: "Why Choose Us",
    iconStyle: "check",
    layout: "grid",
    subheading:
      "Experience the difference of working with true professionals who care about quality.",
  },
  fields: {
    heading: {
      ...BenefitsListFields.heading,
      contentEditable: true,
      render: ({ value, onChange, field }) => (
        <RegenerableTextField
          value={value || ""}
          onChange={onChange}
          namespace="benefits.heading"
          label="Heading"
          multiline={false}
          fieldMeta={field?.metadata}
        />
      ),
    },
    subheading: {
      ...BenefitsListFields.subheading,
      contentEditable: true,
      render: ({ value, onChange, field }) => (
        <RegenerableTextField
          value={value || ""}
          onChange={onChange}
          namespace="benefits.subheading"
          label="Subheading"
          multiline={true}
          fieldMeta={field?.metadata}
        />
      ),
    },
    layout: BenefitsListFields.layout,
    iconStyle: BenefitsListFields.iconStyle,
    columns: BenefitsListFields.columns,
    benefits: BenefitsListFields.benefits as any,
    accentColor: BenefitsListFields.accentColor,
    backgroundColor: BenefitsListFields.backgroundColor,
  },
  // Display label names the structure, not one use: an icon list serves
  // Benefits, credentials, inclusions, or values equally. The registry key
  // Stays BenefitsList — it's persisted in every page's Puck data.
  label: "Icon List",
  render: ({ id, puck: _puck, editMode: _editMode, ...props }) => <BenefitsList id={id} {...props} />,
  /**
   * Columns only apply to the grid layout, and the per-item icon is only read when the icon
   * style is "custom" — otherwise every item takes the one shared icon.
   */
  resolveFields: (data, { fields }) => {
    const props = (data.props || {}) as { layout?: string; iconStyle?: string },
      visible = { ...(fields as Record<string, any>) };

    if (props.layout !== "grid") {
      delete visible.columns;
    }

    if (props.iconStyle !== "custom" && visible.benefits?.arrayFields?.icon) {
      const { icon: _icon, ...arrayFields } = visible.benefits.arrayFields;
      visible.benefits = { ...visible.benefits, arrayFields };
    }

    return visible as typeof fields;
  },
};

export { BenefitsListConfig };
